import { Component, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonService } from '../../common.service';
import { ToolProvider } from '../../../app/tool/tool.service';
import { CacheService } from 'ionic-cache';
import { compress } from 'compress-json';

@Component({
  selector: 'workOfflineDialog',
  templateUrl: 'workOffline.html'
})
export class WorkOfflineDialog implements AfterViewInit {
  public title: string;
  public message: string;
  public data: ToolProvider;
  public totalGroupings: number = 0;
  public completedCount: number = 0;
  public failedCount: number = 0;
  public failedFetch: boolean = true;
  public completedFetch: boolean = false;
  private cancelFetch: boolean = false;
  @Output() dialogDist: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    public dialogRef: MatDialogRef<WorkOfflineDialog>,
    public commonService: CommonService,
    public cache: CacheService
  ) {}

  closeDistModal = () => {
    this.cancelFetch = true;
    this.dialogRef.close({
      gotAllData: this.totalGroupings === this.completedCount
    });
  };

  ngAfterViewInit() {
    this.dialogRef.disableClose = true;
    this.cacheParamsAndRecsForOfflineMode();
  }

  cacheParamsAndRecsForOfflineMode = async () => {
    const totalKeys = await this.data.getProductkeyCount();
    this.totalGroupings = Math.ceil(totalKeys / 100);

    this.cache.saveItem('mapModeTwoProductKeyCount', this.totalGroupings);

    for (let grouping = 0; grouping < this.totalGroupings; grouping++) {
      if (this.cancelFetch) {
        break;
      }

      const returnedParams = await this.data.getSetOfParamsAndRecs(grouping);

      if (returnedParams) {
        for (const key in returnedParams) {
          this.cache.saveItem(`paramsAndRecs-${key}`, compress(returnedParams[key]), 'paramsAndRecs');
        }
        this.completedCount++;
      } else {
        this.failedCount++;
        this.failedFetch = true;
      }
    }
    this.completedFetch = true;
  };
}
